import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getDocs, collection, setDoc, doc } from "firebase/firestore";
import { db } from "./firebase"; 
import "./index.css";
import BookLessonModal from "./BookLessonModal";
import { getDoc } from "firebase/firestore";

function TutorLayout({ children }) {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const auth = getAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    setTimeout(async () => {
      try {
        await signOut(auth);
        window.location.href = "/";
      } catch (error) {
        console.error("Logout failed:", error);
        setIsLoggingOut(false);
      }
    }, 1000);
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen((prev) => (prev === menu ? null : menu));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


useEffect(() => {
  const fetchHandInNotifications = async () => {
    try {
      const progressSnap = await getDocs(collection(db, "assignmentProgress"));
      const handedInItems = progressSnap.docs
        .filter(doc => {
          const data = doc.data();
          return data.handedIn === true && data.notified !== true;
        });

      const notificationsWithNames = await Promise.all(
        handedInItems.map(async (docSnap) => {
          const data = docSnap.data();
          const [assignmentID, studentUID] = docSnap.id.split("_");

          // Fetch student info
          const userRef = doc(db, "users", studentUID);
          const userSnap = await getDoc(userRef);
          const userData = userSnap.exists() ? userSnap.data() : {};

          return {
            id: docSnap.id,
            ...data,
            studentName: userData.displayName && userData.surname
              ? `${userData.displayName} ${userData.surname}`
              : studentUID, // fallback
          };
        })
      );

      setNotifications(notificationsWithNames);
      setNotificationCount(notificationsWithNames.length);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  };

  fetchHandInNotifications();
}, []);


  if (isLoggingOut) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "1.5rem",
        fontWeight: "bold",
        backgroundColor: "#fffbe6",
      }}>
        Logging out...
      </div>
    );
  }

  return (
    <div>
      <nav style={styles.navbar}>
        <div style={styles.leftNav}>
          <div style={styles.logo}>🎓 Tutor Panel</div>

          <div style={styles.links} ref={dropdownRef}>
            <Link to="/tutor-dashboard" className="nav-link">Dashboard</Link>

            {/* Manage Accounts */}
            <div style={styles.dropdown}>
              <button onClick={() => toggleDropdown("accounts")} style={styles.dropdownButton}>Manage Accounts ▼</button>
              {dropdownOpen === "accounts" && (
                <div style={styles.dropdownContent}>
                  <Link to="/view-users" className="dropdown-link">View Users</Link>
                  <Link to="/create-user" className="dropdown-link">Create User</Link>
                  <Link to="/edit-user" className="dropdown-link">Edit User</Link>
                </div>
              )}
            </div>

            {/* Manage Bookings */}
            <div style={styles.dropdown}>
              <button onClick={() => toggleDropdown("bookings")} style={styles.dropdownButton}>Manage Bookings ▼</button>
              {dropdownOpen === "bookings" && (
                <div style={styles.dropdownContent}>
                  <Link to="/all-bookings" className="dropdown-link">All Bookings</Link>
                  <div className="dropdown-link" onClick={() => setShowBookingModal(true)} style={{ userSelect: "none" }}>Book Lesson</div>
                </div>
              )}
            </div>

            {/* Question Manager */}
            <div style={styles.dropdown}>
              <button onClick={() => toggleDropdown("create")} style={styles.dropdownButton}>Question Manager ▼</button>
              {dropdownOpen === "create" && (
                <div style={styles.dropdownContent}>
                  <Link to="/question-builder" className="dropdown-link">✍️ Create Quick-Fire Questions</Link>
                  <Link to="/worded-question-builder" className="dropdown-link">📄 Create Worded Questions</Link>
                </div>
              )}
            </div>

            {/* Assignment Manager */}
            <div style={styles.dropdown}>
              <button onClick={() => toggleDropdown("assignments")} style={styles.dropdownButton}>Assignment Manager ▼</button>
              {dropdownOpen === "assignments" && (
                <div style={styles.dropdownContent}>
                  <Link to="/assignment-builder" className="dropdown-link">Create an Assignment</Link>
                  <Link to="/view-assignments" className="dropdown-link">View Assignments</Link>
                </div>
              )}
            </div>

            {/* Manage Classwork */}
            <div style={styles.dropdown}>
              <button onClick={() => toggleDropdown("classwork")} style={styles.dropdownButton}>Manage Classwork ▼</button>
              {dropdownOpen === "classwork" && (
                <div style={styles.dropdownContent}>
                  <Link to="/tutor-classwork-page" className="dropdown-link">View Classwork</Link>
                  <Link to="/create-lesson-folder" className="dropdown-link">Create Lesson Folder</Link>
                </div>
              )}
            </div>

            <Link to="/set-homework-page" className="nav-link">Set Homework</Link>
            <Link to="/review-work" className="nav-link">Review Work</Link>
            <Link to="/tutor-help-page" className="nav-link">Help</Link>
          </div>
        </div>

       <div style={styles.rightNav}>
  <div
    style={styles.notificationWrapper}
    onClick={() => setNotificationsOpen(prev => !prev)}
  >
    🔔
    {notificationCount > 0 && (
      <span style={styles.notificationBadge}>{notificationCount}</span>
    )}
    {notificationsOpen && (
      <div style={styles.notificationDropdown}>
        <div style={styles.clearAllWrapper}>
          <span
            style={styles.clearAllLink}
            onClick={async () => {
  try {
    const snapshot = await getDocs(collection(db, "assignmentProgress"));
    const unreadDocs = snapshot.docs.filter(doc => {
      const data = doc.data();
      return data.handedIn && !data.notified;
    });

    for (const docSnap of unreadDocs) {
      await setDoc(
        doc(db, "assignmentProgress", docSnap.id),
        { notified: true },
        { merge: true }
      );
    }

    // Update local state: mark all as read, and reset badge count
   setNotifications([]);

    setNotificationCount(0);
  } catch (error) {
    console.error("Failed to clear notifications:", error);
  }
}}

          >
            Clear All
          </span>
        </div>
        {notifications.length === 0 ? (
          <div style={styles.notificationItem}>No notifications</div>
        ) : (
          <>
            {notifications.map((n, index) => {
              const [assignmentID, studentUID] = n.id.split("_");

              const handleClick = async () => {
                navigate(
                  `/review-homework?student=${studentUID}&assignment=${assignmentID}`
                );

                try {
                  await setDoc(
                    doc(db, "assignmentProgress", n.id),
                    { notified: true },
                    { merge: true }
                  );

                  setNotifications((prev) =>
                    prev.map((item) =>
                      item.id === n.id ? { ...item, notified: true } : item
                    )
                  );

                  if (!n.notified) {
                    setNotificationCount((prev) => Math.max(prev - 1, 0));
                  }
                } catch (err) {
                  console.error("Failed to mark notification as read:", err);
                }
              };

              return (
                <div
                  key={n.id || index}
                  style={{
                    ...styles.notificationItem,
                    cursor: "pointer",
                    backgroundColor: n.notified ? "#fff" : "#fff9c4",
                    fontWeight: n.notified ? "normal" : "bold",
                  }}
                  onClick={handleClick}
                >
                  📤 Homework handed in by{" "}
                  <b>{n.studentName || studentUID}</b>
                </div>
              );
            })}
          </>
        )}
      </div>
    )}
  </div>

  <button onClick={handleLogout} className="logout-button">
    Log Out
  </button>
</div>

      </nav>
<main style={{ overflow: "visible", position: "relative", zIndex: 1 }}>
  {children}
</main>

      {showBookingModal && <BookLessonModal onClose={() => setShowBookingModal(false)} />}
    </div>
  );
}

const styles = {
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 2rem",
    backgroundColor: "#fef6e4",
    borderBottom: "1px solid #ddd",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    fontFamily: "'Poppins', sans-serif",
  },
  leftNav: {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
  },
  logo: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#3a3a3a",
  },
  links: {
    display: "flex",
    alignItems: "center",
    gap: "1.5rem",
    position: "relative",
  },
  dropdown: {
    position: "relative",
  },
  dropdownButton: {
    background: "none",
    border: "none",
    color: "#333",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    padding: 0,
  },
  dropdownContent: {
    position: "absolute",
    top: "130%",
    left: 0,
    backgroundColor: "#ffffff",
    border: "1px solid #ccc",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    padding: "0.5rem 1rem",
    zIndex: 999,
    minWidth: "180px",
  },
  dropdownLink: {
    display: "block",
    padding: "0.4rem 0",
    color: "#333",
    textDecoration: "none",
    fontSize: "0.95rem",
    cursor: "pointer",
  },
  notificationWrapper: {
    position: "relative",
    fontSize: "1.5rem",
    cursor: "pointer",
    marginRight: "1.5rem"
  },
  notificationBadge: {
    position: "absolute",
    top: "-6px",
    right: "-10px",
    backgroundColor: "#d63031",
    color: "#fff",
    borderRadius: "50%",
    padding: "2px 6px",
    fontSize: "0.7rem",
    fontWeight: "bold",
  },
  notificationDropdown: {
    position: "absolute",
    top: "110%",
    right: "0",
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: "8px",
    width: "260px",
    maxHeight: "300px",
    overflowY: "auto",
    zIndex: 1000,
    padding: "0.5rem",
  },
  notificationItem: {
    padding: "0.6rem 0.8rem",
    borderBottom: "1px solid #eee",
    fontSize: "0.9rem",
    color: "#2d3436",
  },
  clearAllWrapper: {
  display: "flex",
  justifyContent: "flex-end",
  padding: "0 0.5rem 0.3rem 0.5rem",
},

clearAllLink: {
  fontSize: "0.8rem",
  color: "#d63031",
  cursor: "pointer",
  textDecoration: "underline",
  fontWeight: 500,
},
rightNav: {
  display: "flex",
  alignItems: "center",
  gap: "1rem",
},

};

export default TutorLayout;